import omitBy from 'lodash/omitBy'
import isNil from 'lodash/isNil'
import merge from 'lodash/merge'
import Vue from 'vue'
import Ncs from 'ncs'
import config from '../search/ncs_config'
import KwicHeader from './KwicHeader'
import ContextHeader from './ContextHeader'
import ContextSourceText from './ContextSourceText'


const components = {
  ...Ncs.defaultComponents,
  NcsKwicResultHeader: KwicHeader,
  NcsContextDocumentHeader: ContextHeader,
  NcsContextSourceText: ContextSourceText
}

function csvElementFields(document, text, elements, matches) {
  return omitBy({
    [this.$i18n.t('result.context.header.document.nombre')]: document.nombre,
    [this.$i18n.t('result.context.header.document.apellidos')]: document.apellidos,
    [this.$i18n.t('result.context.header.document.pseudonimo')]: document.pseudonimo,
    [this.$i18n.t('result.context.header.document.titulo_columna')]: document.titulo_columna,
    [this.$i18n.t('result.context.header.document.periodico')]: document.periodico,
    [this.$i18n.t('result.context.header.document.lugar_publicacion')]: document.lugar_publicacion,
    [this.$i18n.t('result.context.header.document.fecha_publicacion')]: document.fecha_publicacion,
    [this.$i18n.t('result.context.header.document.pagina')]: document.pagina,
    [this.$i18n.t('result.context.header.document.identificador')]: document.identificador,
    [this.$i18n.t('result.context.header.document.titulo_articulo')]: document.titulo_articulo,
    [this.$i18n.t('result.context.header.document.medio')]: document.medio,
    [this.$i18n.t('result.context.header.document.idioma')]: document.idioma,
    [this.$i18n.t('result.context.header.document.pais')]: document.pais,
    [this.$i18n.t('result.context.header.document.enlace')]: document.enlace,
    [this.$i18n.t('result.context.header.document.neologismo')]: document.neologismo,
    [this.$i18n.t('result.context.header.document.etimologia')]: document.etimologia,
    [this.$i18n.t('result.context.header.document.otro')]: document.otro,
    [this.$i18n.t('result.context.header.document.profesion')]: document.profesion?.join(', '),
    [this.$i18n.t('result.context.header.document.estilo')]: document.estilo?.join(', '),
    [this.$i18n.t('result.context.header.document.politica_linguistica')]: document.politica_linguistica?.join(', '),
    [this.$i18n.t('result.context.header.document.dimension_linguistica')]: document.dimension_linguistica?.join(', '),
    [this.$i18n.t('result.context.header.document.procedimientos')]: document.procedimientos?.join(', '),
    [this.$i18n.t('result.context.header.document.prestamos')]: document.prestamos?.join(', '),
    [this.$i18n.t('result.context.header.document.formacion')]: document.formacion?.join(', '),
    [this.$i18n.t('result.context.header.document.fraseologia')]: document.fraseologia?.join(', '),
    [this.$i18n.t('result.context.header.document.estrategias')]: document.estrategias?.join(', '),
    [this.$i18n.t('result.context.header.document.tipos')]: document.tipos?.join(', '),
  }, v => v === '' || isNil(v))
}

Vue.use(Ncs, {config: merge(gon.config, config), components, csvElementFields})

export {Vue, Ncs}
